import React from 'react'

import Icon from '@/components/common/Icon'

const IconUOB: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, height, width }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 21 6"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3846_8239)">
      <path
        d="M4.30176 5.6501C4.30176 5.78672 4.48959 5.80373 4.59201 5.80373H4.67741C4.93347 5.78689 4.93347 5.6843 4.93347 5.6501V0.153634C4.95031 0.0168459 4.76265 0 4.64321 0H4.59268C4.48958 0 4.30176 0.0168459 4.30176 0.153634V5.6501Z"
        fill="#E1091D"
      />
      <path
        d="M0.870117 5.6501C0.870117 5.78672 1.05795 5.80373 1.16037 5.80373H1.24579C1.50184 5.78689 1.50184 5.6843 1.50184 5.6501V0.153634C1.50184 0.0168459 1.33102 0 1.21158 0H1.16105C1.04077 0 0.870117 0.0168459 0.870117 0.153634V5.6501Z"
        fill="#E1091D"
      />
      <path
        d="M2.01465 5.6501C2.01465 5.78672 2.20249 5.80373 2.30491 5.80373H2.40733C2.66339 5.78689 2.66339 5.6843 2.66339 5.6501V0.153634C2.66339 0.0168459 2.47556 0 2.37314 0H2.30491C2.20249 0 2.01465 0.0168459 2.01465 0.153634V5.6501Z"
        fill="#E1091D"
      />
      <path
        d="M3.1582 5.6501C3.1582 5.78672 3.34603 5.80373 3.44846 5.80373H3.53386C3.78992 5.78689 3.78992 5.6843 3.78992 5.6501V0.153634C3.78992 0.0168459 3.60209 0 3.49967 0H3.44913C3.34603 0 3.1582 0.0168459 3.1582 0.153634V5.6501Z"
        fill="#E1091D"
      />
      <path
        d="M0.153633 2.57715C0.0168483 2.57715 0 2.76498 0 2.8674V2.96983C0.016848 3.22588 0.119438 3.22588 0.153633 3.22588H5.6501C5.78672 3.22588 5.80373 3.03805 5.80373 2.93563V2.8674C5.80373 2.76498 5.78689 2.57715 5.6501 2.57715H0.153633Z"
        fill="#E1091D"
      />
      <path
        d="M13.8094 4.64294C12.9047 4.64294 12.5628 4.14784 12.5628 2.86772C12.5628 1.60428 12.887 1.14372 13.7925 1.14372H13.8262C14.7138 1.14372 15.0559 1.60462 15.0559 2.86772C15.0391 4.14801 14.6975 4.64294 13.8094 4.64294ZM13.8094 0.426758C12.273 0.426758 11.5732 1.19493 11.5732 2.88474C11.5732 4.55753 12.2902 5.3599 13.7581 5.37691H13.8264C15.3115 5.37691 16.0283 4.55753 16.0283 2.88474C16.0283 1.17775 15.3457 0.426758 13.8094 0.426758Z"
        fill="#002469"
      />
      <path
        d="M7.61304 5.00128C7.92031 5.24032 8.34701 5.34274 9.02977 5.34274H9.06346C9.74622 5.34274 10.1729 5.24032 10.4974 5.00128C10.9411 4.65998 11.027 4.25113 11.027 3.48212V0.699859C11.0291 0.674777 11.0256 0.649546 11.0169 0.625941C11.0082 0.602337 10.9944 0.580934 10.9765 0.563239C10.9074 0.494508 10.7538 0.460816 10.4977 0.460816C10.3369 0.440275 10.1739 0.476497 10.0368 0.563239C10.0189 0.580933 10.0051 0.602336 9.9964 0.625941C9.98766 0.649545 9.9842 0.674777 9.98628 0.699859V3.60173C9.98628 4.07964 9.98628 4.18207 9.76443 4.3699C9.54518 4.50714 9.28866 4.57278 9.03044 4.55773C8.77133 4.58097 8.5121 4.51435 8.2963 4.36905C8.07444 4.19841 8.07444 4.09598 8.07444 3.61807V0.699859C8.07652 0.674777 8.07307 0.649545 8.06433 0.625941C8.0556 0.602336 8.0418 0.580933 8.0239 0.563239C7.88655 0.476226 7.72309 0.439994 7.56183 0.460816C7.40095 0.440275 7.23796 0.476497 7.10093 0.563239C7.08303 0.580933 7.06923 0.602336 7.0605 0.625941C7.05177 0.649545 7.04832 0.674777 7.05039 0.699859V3.48212C7.08409 4.25029 7.1528 4.65998 7.61371 5.00128"
        fill="#002469"
      />
      <path
        d="M18.6737 4.62606H17.5813V3.17512H18.742C19.3907 3.17512 19.5101 3.44819 19.5101 3.9091C19.527 4.52363 19.3053 4.62606 18.6737 4.62606ZM17.5813 1.16087H18.6907C19.2711 1.16087 19.3053 1.45112 19.3053 1.82661C19.3053 2.28752 19.1004 2.47518 18.6055 2.47518H17.5813V1.16087ZM19.8858 0.751174C19.6297 0.563343 19.3225 0.495117 18.7251 0.495117H16.7449C16.6996 0.495206 16.6563 0.513213 16.6243 0.545197C16.5923 0.57718 16.5743 0.620534 16.5742 0.665766V5.1722C16.5743 5.21743 16.5923 5.26078 16.6243 5.29277C16.6563 5.32475 16.6996 5.34276 16.7449 5.34285H18.8274C19.3907 5.34285 19.7832 5.326 20.1245 5.06978C20.5 4.77952 20.5684 4.31879 20.5684 3.97732C20.5809 3.7878 20.5488 3.59797 20.4747 3.42308C20.4006 3.2482 20.2866 3.09311 20.1417 2.97028C20.0196 2.89072 19.8876 2.82756 19.749 2.78245L19.6636 2.74875L19.749 2.71506C20.1587 2.52723 20.2953 2.25416 20.2953 1.72503C20.2785 1.45196 20.2271 0.991059 19.8856 0.752016"
        fill="#002469"
      />
    </g>
    <defs>
      <clipPath id="clip0_3846_8239">
        <rect width="20.5714" height="5.80373" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default Icon(IconUOB)
